import { createSlice } from '@reduxjs/toolkit';

import { PageSizing } from 'Shared/Core/Common/Options/PageSizing';

import { getAllVahedHayeBimehByNoeVahedBimehPagedFilter } from './action';
import IVahedHayeBimehListState from './model';

const initialState: IVahedHayeBimehListState = {
  vahedHayeBimeh: {
    loading: false,
    data: {
      pageNumber: 0,
      pageSize: PageSizing[1].value as number,
      totalCount: 0,
      queryResult: null,
    },
    queryParams: {
      pageNumber: 1,
      pageSize: 10,
      needTotalCount: true,
      sortAscending: false,
      sortBy: null,
    },
    pagination: {
      currentPage: 1,
      tableColumn: 0,
      totalPage: 0,
      customPageSize: PageSizing[1].value as number,
      firstItemNumber: 0,
      lastItemNumber: 0,
    },
  },
};

export const vahedHayeBimehListSlice = createSlice({
  name: 'vahedHayeBimeh/VahedHayeBimehList',
  initialState,
  reducers: {
    setTotalPage: (state, action) => {
      state.vahedHayeBimeh.pagination.totalPage = action.payload;
    },
    setNextPage: (state) => {
      if (state.vahedHayeBimeh.pagination.currentPage < state.vahedHayeBimeh.pagination.totalPage) {
        state.vahedHayeBimeh.pagination.currentPage = state.vahedHayeBimeh.pagination.currentPage + 1;
        state.vahedHayeBimeh.queryParams.pageNumber = state.vahedHayeBimeh.pagination.currentPage;
      }
    },
    setPervPage: (state) => {
      if (state.vahedHayeBimeh.pagination.currentPage > 1) {
        state.vahedHayeBimeh.pagination.currentPage = state.vahedHayeBimeh.pagination.currentPage - 1;
        state.vahedHayeBimeh.queryParams.pageNumber = state.vahedHayeBimeh.pagination.currentPage;
      }
    },
    setFirstPage: (state) => {
      state.vahedHayeBimeh.pagination.currentPage = 1;
      state.vahedHayeBimeh.queryParams.pageNumber = state.vahedHayeBimeh.pagination.currentPage;
    },
    setEndPage: (state) => {
      state.vahedHayeBimeh.pagination.currentPage = state.vahedHayeBimeh.pagination.totalPage;
      state.vahedHayeBimeh.queryParams.pageNumber = state.vahedHayeBimeh.pagination.currentPage;
    },
    setCurrentPage: (state, action) => {
      state.vahedHayeBimeh.pagination.currentPage = action.payload;
      state.vahedHayeBimeh.queryParams.pageNumber = state.vahedHayeBimeh.pagination.currentPage;
    },
    setCustomPageSize: (state, action) => {
      state.vahedHayeBimeh.pagination.customPageSize = action.payload;
      state.vahedHayeBimeh.queryParams.pageSize = state.vahedHayeBimeh.pagination.customPageSize;
    },
    setParams: (state, action) => {
      state.vahedHayeBimeh.queryParams = action.payload;
      state.vahedHayeBimeh.pagination.currentPage = action.payload.pageNumber;
    },
    setFirstItemNumber: (state, action) => {
      state.vahedHayeBimeh.pagination.firstItemNumber = action.payload;
    },
    setLastItemNumber: (state, action) => {
      state.vahedHayeBimeh.pagination.lastItemNumber = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllVahedHayeBimehByNoeVahedBimehPagedFilter.pending, (state) => {
        state.vahedHayeBimeh.loading = true;
      })
      .addCase(getAllVahedHayeBimehByNoeVahedBimehPagedFilter.fulfilled, (state, action) => {
        state.vahedHayeBimeh.loading = false;
        if (action.payload !== undefined) {
          state.vahedHayeBimeh.data = action.payload;
        }
        return state;
      })
      .addCase(getAllVahedHayeBimehByNoeVahedBimehPagedFilter.rejected, (state) => {
        state.vahedHayeBimeh.loading = false;
      });
  },
});

export const {
  setTotalPage,
  setNextPage,
  setPervPage,
  setFirstPage,
  setEndPage,
  setCurrentPage,
  setCustomPageSize,
  setParams,
  setFirstItemNumber,
  setLastItemNumber,
} = vahedHayeBimehListSlice.actions;

export default vahedHayeBimehListSlice.reducer;
